module.exports = __webpack_public_path__ + "img/porosity_tile.9a94e463.jpg";